// firebase.js
import { getDatabase } from "firebase/database";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkhWohj6qZvnkfAKByCZ5Hx66epsvsIRM",
  authDomain: "warga-bicara.firebaseapp.com",
  databaseURL: "https://warga-bicara-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "warga-bicara",
  storageBucket: "warga-bicara.firebasestorage.app",
  messagingSenderId: "793444164140",
  appId: "1:793444164140:web:df46bfe7e896d85d18a789"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
